enum FormFields {
  TotalPrice = 'totalPrice',
  DownPayment = 'downPayment',
  InterestRate = 'interestRate',
  Term = 'term',
  TaxRate = 'taxRate',
  InsuranceRate = 'insuranceRate',
  LastRecalculationMoment = 'lastRecalculationMoment',
  InsuranceChecked = 'insuranceChecked',
  TaxChecked = 'taxChecked',
}

const FormFieldsList = [
  FormFields.TotalPrice,
  FormFields.DownPayment,
  FormFields.InsuranceRate,
  FormFields.Term,
  FormFields.TaxRate,
  FormFields.InterestRate,
  FormFields.LastRecalculationMoment,
  FormFields.TaxChecked,
  FormFields.InsuranceChecked,
];

export { FormFields, FormFieldsList };
